<template>
  <Menu.Dropdown
    id="editor-mode-dropdown"
    :label="EDITOR_MODES[modelValue].label"
  >
    <Menu.CheckboxItem
      :model-value="modelValue === 'plaintext'"
      label="Markdown mode"
      icon="code-bracket"
      @update:model-value="switchMode('plaintext')"
    />

    <Menu.CheckboxItem
      :model-value="modelValue === 'fancy'"
      label="Fancy mode"
      icon="sparkles"
      @update:model-value="switchMode('fancy')"
    />

    <Tooltip.PremiumOnly
      v-slot="{ planRequired, redirect }"
      feature="naked_mode"
    >
      <Menu.CheckboxItem
        :model-value="modelValue === 'naked'"
        label="Naked mode"
        icon="file-code"
        :premium="!!planRequired"
        @update:model-value="!planRequired ? switchMode('naked') : redirect()"
      />
    </Tooltip.PremiumOnly>
  </Menu.Dropdown>

  <ToNakedModeConfirmation
    v-if="modeSwitch.isSwitchingToNakedMode.value"
    :email="{
      subject: subject || '',
      body: body || '',
      template: template || undefined,
    }"
    @close="modeSwitch.closeNakedModeConfirmation"
    @submit="modeSwitch.handleSwitchToNakedMode"
  />

  <EditorModeConfirmation
    v-if="modeSwitch.modeTransition.value"
    :transition="modeSwitch.modeTransition.value"
    @close="modeSwitch.closeModeTransitionConfirmation"
    @switch="modeSwitch.handleModeTransition"
  />
</template>

<script setup lang="ts">
import EditorModeConfirmation from "@/components/modals/EditorModeConfirmation.vue";
import ToNakedModeConfirmation from "@/components/modals/ToNakedModeConfirmation.vue";
import Menu from "@/design_system/Menu";
import Tooltip from "@/design_system/Tooltip";
import { useEditorModeSwitch } from "@/lib/composables/editor-mode-switch";
import { EDITOR_MODES } from "@/lib/editor/editor-modes";
import type { EditorMode, NewsletterEmailTemplate } from "@/types/email";

defineProps<{
  subject?: string;
}>();

const mode = defineModel<EditorMode>({ required: true });
const body = defineModel<string>("body", {
  default: "",
});
const template = defineModel<NewsletterEmailTemplate | null | undefined>(
  "template",
  {
    required: true,
  }
);

const modeSwitch = useEditorModeSwitch({
  mode,
  body,
  onModeChange: (next) => {
    mode.value = next;
  },
  onSwitchToNakedMode: (incomingBody) => {
    mode.value = "naked";
    template.value = "naked";
    body.value = incomingBody;
  },
  onClearBodyForModeTransition: () => {
    template.value = "plaintext";
    body.value = "";
  },
});

const switchMode = modeSwitch.switchMode;
</script>
